import AdminNoticeBanner from './AdminNoticeBanner';

export default AdminNoticeBanner;
